/* eslint-disable import/prefer-default-export */

export const MetricsViewOptions = {
  KAM: 'KAM',
  DISTRIBUTOR: 'DISTRIBUTOR'
};

export const QuotesMetricsBalanceOptions = {
  AMOUNT: 'AMOUNT',
  COUNT: 'COUNT'
};

export const QuoteTrimesterField = {
  ACCEPTED: 'quotesAccepted',
  IN_DRAFT: 'quotesInDraft',
  IN_REVIEW: 'quotesInReview',
  REJECTED: 'quotesRejected',
  ARCHIVED: 'quotesArchived'
};

export const MetricsPeriodOptions = {
  MONTH:    'MONTH',
  QUARTER:  'QUARTER',
  YEAR:     'YEAR',
  HISTORIC: 'HISTORIC'
};
